import { validateData } from '@mc-alberta/strict'
import { launcher, popup as popupManager } from '@mc-alberta/tyrion'
import * as i18nData from '@mc-alberta/i18n-data'
import { lumber } from '@mc-alberta/lumber'
import { isLoggingEnabled } from '../logging'
import checkoutRules from '../../../merchant-parameter.rules.js'
import { EVENTS } from '../../constants'
import getSrciUrl from '../../utils/getSrciUrl'
import srciMessenger from '../../helpers/messenger'
import initializer from '../../helpers/initializer'
import state from '../../state'
import { abortCheckout } from './endSession'
import handleSrciRequest from './handleSrciRequest'
import handleSrciStateRequest from './handleSrciStateRequest'
import handleSrciReady from './handleSrciReady'
import handleEnrollmentErrorHandlingReceipt from './handleEnrollmentErrorHandlingReceipt'
import launchDCF from './launchDCF'
import events from '../../../events.json'

// Post-messages expected from SRCI
const listeners = [
  { name: EVENTS.READY, handler: handleSrciReady },
  { name: EVENTS.GET_NORMALIZED_MERCHANT_DATA, handler: initializer.getNormalizedMerchantData },
  { name: EVENTS.CANCEL, handler: abortCheckout },
  { name: EVENTS.LAUNCH_DCF, handler: launchDCF },
  { name: EVENTS.SRCI_REQUEST, handler: handleSrciRequest },
  { name: EVENTS.SRCI_STATE_REQUEST, handler: handleSrciStateRequest },
  { name: EVENTS.DID_HANDLE_ENROLLMENT_ERROR, handler: handleEnrollmentErrorHandlingReceipt }
]

export async function checkout (merchantParameters) {
  // TODO: Add strict validation when comment is addressed:
  // https://fusion.mastercard.int/stash/projects/ALBERTA/repos/trident-alberta-e2e/browse/src/test/java/com/mastercard/trident/checkout/TokenizationTest.java#174
  // if (!validateData(merchantParameters, checkoutRules, { logError: true })) {
  //   throw new Error('Checkout Parameters are Invalid')
  // }
  validateData(merchantParameters, checkoutRules, { logError: isLoggingEnabled })

  // Update locale to be used in the overlay and the popup if displayLanguage was passed in the merchant params
  // TODO: Will be removed when dropping support for `displayLanguage`
  updateLocale(merchantParameters)

  // attempt to create the popup, or retrieve the current popup if existant
  const { isNewWindow } = await launcher.launch(getSrciUrl(), abortCheckout, state.locale)

  // setup post-messaging if needed
  if (isNewWindow) {
    // Setup messenger to talk to our SRCi
    srciMessenger.init(popupManager.getWindow(), process.env.MASTERCARD_SRC_HOST)

    // Update the transaction parameters asynchronously
    initializer.updateTransaction(merchantParameters)

    // Register the post-message listeners
    srciMessenger.registerListeners(listeners)
  }
}

/**
 * Updates the locale based on the information passed in the runtime parameters or in the url
 * @return {String} locale (format: 'en_US')
 */
function updateLocale ({ displayLanguage } = {}) {
  if (displayLanguage && typeof displayLanguage === 'string') {
    lumber.info({ ...events.infos.LOCALE_PASSED_IN_RUNTIME_PARAMETERS })
    state.locale = i18nData.formatLocale(displayLanguage, '_')
  }
}
